import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { MtPaymentsPageProps } from './types';

export * from './types';

export const MtPaymentsPage: FC<MtPaymentsPageProps> = (props) => {
  const {} = props;
  const { translate } = useTranslation();

  return <>MtPaymentsPage</>;
};
